import React from 'react';
var SelectInput = function SelectInput(_ref) {
  var options = _ref.options,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("select", {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value
  }, options.map(function (option) {
    if (option.label) {
      return /*#__PURE__*/React.createElement("option", {
        key: option.value,
        value: option.value
      }, option.label);
    } else {
      return /*#__PURE__*/React.createElement("option", {
        key: option,
        value: option
      }, option);
    }
  }));
};
export default SelectInput;